export interface cv_TaskFlagMessage {
    C_TaskFlagMessage_key: number;
    TaskFlagMessage: string;
    IsActive: boolean;
    IsDefault: boolean;
    SortOrder: number;
    C_VocabularySource_key: number | null;
    ElementID: string | null;
    IsDeprecated: boolean;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: string;
    ModifiedBy: string;
    DateModified: string;
    Version: number;
}
